// removed by extract-text-webpack-plugin
module.exports = {"container":"_1RbJR","body":"_2QHj8","social-actions":"_2ArNj","copy-to-clipboard-button":"_3ekLB","copy-to-clipboard-input":"_3LpHi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.scss
// module id = ./src/components/ShareWithFriendsPrompts/ShareWithFriendsPrompts.scss
// module chunks = 4